export default __webpack_public_path__ + "static/media/foot-right-side.eacf63cf.png";